import {
  PaneDirective,
  PanesDirective,
  SplitterComponent,
} from '@syncfusion/ej2-react-layouts';
import * as React from 'react';
import Team from './Team';
import Trades from './Trades';
import Assignments from './Assigments';
import ScheduleApp from '../../components/GlobalScheduler';
import MainGrafik from './Charts/MainGrafik';
import FilterContext from '../../context/FilterContext';
interface IProp {}
interface IState {}

class App extends React.Component<IProp, IState> {
  constructor(prop: IProp) {
    super(prop);
  }

  private resizeRaf: number | null = null;
  private triggerWindowResize = () => {
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
    this.resizeRaf = requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
    });
  };

  componentWillUnmount() {
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
  }
  firstPaneContent = () => {
    return (
      <div>
        <div className='content'>
          <div className='Teams'>
            <Team />
          </div>
        </div>
      </div>
    );
  };
  secondPaneContent = () => {
    return (
      <div
       /*  style={{
          height: '93%',
        }} */
      >
        <div
          className='contentMiddle'
          style={{
            height: 'calc(94vh - 20px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <div style={{ width: '100%', height: 'auto' }}>
            <MainGrafik />
          </div>
          <div
            style={{
              width: '100%',
              height: 'auto',
            }}
          >
            <ScheduleApp />
          </div>
        </div>
      </div>
    );
  };
  TradesPaneContent = () => {
    return <Trades />;
  };
  AssignmentsPaneContent = () => {
    return <Assignments />;
  };

  thirdPaneContentSplitter = () => {
    return (
      <SplitterComponent
        id='expand-collapse-inner'
        className='splitter'
        orientation='Vertical'
        height='95vh'
        resizing={this.triggerWindowResize}
        resizeStop={this.triggerWindowResize}
      >
        <PanesDirective>
          <PaneDirective
            min='30%'
            size='35%'
            max='35%'
            content={this.TradesPaneContent}
          />
          <PaneDirective
            min='50%'
            size='60%'
            max='70%'
            content={this.AssignmentsPaneContent}
          />
        </PanesDirective>
      </SplitterComponent>
    );
  };
  render() {
    return (
      <FilterContext.Provider value={this.state}>
        <div
          className='App'
          id='SplitterInner'
          style={{ width: '100%', height: '100vh' }}
        >
          <SplitterComponent id='expand-collapse' className='splitter'
            resizing={this.triggerWindowResize}
            resizeStop={this.triggerWindowResize}
          >
            <PanesDirective>
              <PaneDirective
                size='12.1%'
                max='15.1%'
                content={this.firstPaneContent}
                collapsible={false}
              />
              <PaneDirective size='71.9%' content={this.secondPaneContent} />
              <PaneDirective
                size='17%'
                max='17%'
                content={this.thirdPaneContentSplitter}
                collapsible={false}
              />
            </PanesDirective>
          </SplitterComponent>
        </div>
      </FilterContext.Provider>
    );
  }
}
export default App;
